<table>
  <thead>
    <tr>
      <th class="subtable string">{{'mantenimientoEtiquetadores.reetiquetador.reetiquetador' | translate}}</th>
      <th class="subtable action">
        <i class="fas fa-plus" (click)="new=true;reetiquetadorEditable=''" title="{{'mantenimientoEtiquetadores.reetiquetador.tituloNew' | translate}}"></i>
      </th>
    </tr>
  </thead>
  <tbody>
    <app-etq-rtq-new-edit class="component-in-row" *ngIf="new" [editable]="true" [etiquetadorId]="etiquetadorId"
      (close)="new=$event" (refresh)="toRefresh($event)" (pushMessage)="pushMessage.emit($event)">
    </app-etq-rtq-new-edit>
    <app-etq-rtq-new-edit class="component-in-row" *ngFor="let reetiquetador of reetiquetadoresList"
      [reetiquetadorEtq]="reetiquetador" [editable]="false" [etiquetadorId]="etiquetadorId"
      (refresh)="toRefresh($event)" (pushMessage)="pushMessage.emit($event)"></app-etq-rtq-new-edit>
  </tbody>
  <tfoot *ngIf="reetiquetadoresList && reetiquetadoresList.length < 1 && !new">
    <tr>
      <td colspan="10">
        {{'global.noContent' | translate}}
      </td>
    </tr>
  </tfoot>
</table>
